<div class="ui vertical segment" [ngClass]="{ loading: pending }">
  <div *ngIf="success || error" tamsyMargin marginY="10px">
    <esl-message-toast [(message)]="error"></esl-message-toast>
    <esl-message-toast
      [(message)]="success"
      [messageType]="'success'"
    ></esl-message-toast>
  </div>
  <div
    class="ui label warning-label"
    style="
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: column;
    "
    *ngIf="message"
  >
    <div>{{ message }}</div>
    <button
      *ngIf="redirect_url"
      style="margin-top: 15px"
      class="ui primary button"
    >
      <a href="{{ redirect_url }}" style="color: white">
        Go back to {{ applicationType }} application
      </a>
    </button>
  </div>
  <div
    style="
      height: 72px;
      border-radius: 0;
      display: flex;
      align-items: center;
      padding: 16px;
    "
    class="ui default message"
  >
    <span style="display: flex">
      <svg
        style="position: relative; top: 0.5rem"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 7.5V10.625M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM10 13.125H10.0063V13.1313H10V13.125Z"
          stroke="#2C6ECB"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <h5
        style="
          font-weight: 400;
          font-size: 13px;
          color: #505050;
          margin: 0;
          padding-left: 16px;
        "
      >
        Please verify that your company details are accurate and current. If any
        information is incorrect, please click on the edit icon to make the
        necessary updates.
      </h5></span
    >
  </div>
  <div style="margin-top: 50px !important" fxLayout="row" fxLayoutGap="30px">
    <div class="image-box" fxFlex="20%" fxLayout="column" fxLayoutGap="10px">
      <h6
        style="
          font-size: 12px;
          font-weight: 400;
          color: #00000066;
          padding-top: 20px;
        "
      >
        Company Logo
      </h6>

      <div
        class="side-panel text-center"
        appPadding="5"
        fxLayout="column"
        fxLayoutGap="10px"
        fxLayoutAlign="space-between center"
        style="padding: 1.95rem !important"
      >
        <div fxFlex>
          <img
            style="
              border-radius: 100%;
              margin-top: 15px;
              height: 100px;
              width: 100px;
              object-fit: cover;
            "
            [src]="data.image"
            class="ui circular image"
          />
        </div>
        <div fxFlex>
          <button
            style="margin-top: 20px; font-weight: 300; height: 35px"
            class="ui primary button"
            (click)="popModal()"
            [ngClass]="{ 'orange loading': pending }"
          >
            Change
          </button>
        </div>
      </div>
    </div>

    <div fxFlex="grow">
      <div class="ui segment" id="name" style="padding-right: 0px">
        <div
          fxLayout="row"
          style="margin-bottom: 3rem !important"
          fxLayoutAlign="space-between center"
        >
          <div fxFlex="grow" class="section-header">Company Name</div>
          <div fxLayout="row" fxLayoutGap="10px">
            <!-- <span
              class="square"
              *ngIf="nameStatus === 'EMPTY'"
              [ngClass]="{
                'border-greyBlank': nameStatus == 'EMPTY',
                'border-grey':
                  nameStatus == 'NOT_AVAILABLE' &&
                  companyDetail &&
                  !companyDetail.companyRegVerified,
                'border-green':
                  nameStatus == 'VERIFIED' ||
                  (companyDetail && companyDetail.companyRegVerified),
                'border-red':
                  nameStatus == 'REJECTED' || nameStatus == 'UNVERIFIED',
                'border-orange': nameStatus == 'PENDING'
              }"
            >
              <label
                class="ui empty circular label"
                [ngClass]="{
                  'label-greyBlank': nameStatus == 'EMPTY',
                  'label-grey':
                    nameStatus == 'NOT_AVAILABLE' &&
                    companyDetail &&
                    !companyDetail.companyRegVerified,
                  'label-green':
                    nameStatus == 'VERIFIED' ||
                    (companyDetail && companyDetail.companyRegVerified),
                  'label-red':
                    nameStatus == 'REJECTED' || nameStatus == 'UNVERIFIED',
                  'label-orange': nameStatus == 'PENDING'
                }"
              ></label>
            </span> -->
            <div
              [ngClass]="{
                'label-greyBlank': nameStatus == 'EMPTY',
                'label-grey':
                  nameStatus == 'NOT_AVAILABLE' &&
                  companyDetail &&
                  !companyDetail.companyRegVerified,
                'label-green':
                  nameStatus == 'VERIFIED' ||
                  (companyDetail && companyDetail.companyRegVerified),
                'label-red':
                  nameStatus == 'REJECTED' || nameStatus == 'UNVERIFIED',
                'label-orange': nameStatus == 'PENDING'
              }"
              class="ui tiny circular label"
              style="
                height: 20px !important;
                padding: 0 10px !important;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                font-weight: 400;
                white-space: nowrap;
              "
            >
              {{
                nameStatus == "PENDING"
                  ? "PENDING VERIFICATION"
                  : nameStatus == "FAILED"
                  ? "FAILED VERIFICATION"
                  : nameStatus == "UNVERIFIED"
                  ? "UNVERIFIED"
                  : nameStatus == "VERIFIED"
                  ? "VERIFIED"
                  : nameStatus
              }}
            </div>

            <button
              suiPopup
              [popupInverted]="true"
              popupPlacement="bottom"
              popupText="View History"
              (click)="viewHistory('COMPANY_NAME')"
              class="ui tiny button"
            >
              <img
                style="position: relative; right: 0.7em; bottom: 0.1rem"
                src="/assets/icons/Group 416.svg"
              />
            </button>
            <button
              *ngIf="nameStatus !== 'VERIFIED'"
              suiPopup
              [popupInverted]="true"
              popupPlacement="bottom"
              popupText="Request Edit"
              style="margin-right: 0px !important"
              (click)="editDetail('COMPANY_NAME')"
              class="ui tiny button not_tiny"
            >
              <img
                style="position: relative; right: 0.5em; bottom: 0.1rem"
                src="/assets/icons/pen.svg"
              />
            </button>
          </div>
        </div>
        <div
          *ngIf="nameStatus == 'PENDING'"
          class="ui message"
          style="
            background-color: #fff2e2;
            display: flex;
            width: 389px;
            position: absolute;
            right: 0;
            padding: 2px 4px 2px 4px;
            top: 1.6rem;
            margin-top: 2.4rem;
          "
        >
          <h6 style="font-size: 10px; font-weight: 400; color: #505050">
            <span
              style="
                margin-right: 9px;
                margin-left: 5px;
                vertical-align: middle;
              "
              ><svg
                width="12"
                height="11"
                viewBox="0 0 12 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.99915 4.7507V6.6257M1.34753 8.31352C0.914839 9.06352 1.45612 10.0007 2.32199 10.0007H9.67632C10.5422 10.0007 11.0835 9.06352 10.6508 8.31352L6.97361 1.93977C6.54068 1.18935 5.45763 1.18935 5.02469 1.93977L1.34753 8.31352ZM5.99915 8.1257H6.0029V8.12945H5.99915V8.1257Z"
                  stroke="#505050"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                /></svg></span
            >The details you've submitted for verification will be visible upon
            NCC's approval.
          </h6>
        </div>
        <div class="ui divider"></div>

        <form class="ui form" appMargin marginT="20px">
          <div class="field" appMargin marginB="15px">
            <h6 style="font-size: 12px; color: #00000066; font-weight: 400">
              Company Name
            </h6>
            <h4 style="margin-top: -1rem; color: #505050">
              {{ organization?.jpaContractor?.companyName || "--" }}
            </h4>
            <!-- <div class="ui input">
              <input
                type="text"
                [value]="organization?.jpaContractor?.companyName"
                disabled
              />
            </div> -->
          </div>
        </form>
        <div class="ui divider"></div>
      </div>

      <div
        class="ui segment"
        id="rcNumber"
        *ngIf="!isMda"
        style="padding-right: 0px"
      >
        <div
          fxLayout="row"
          style="margin-bottom: 3rem !important"
          fxLayoutAlign="space-between center"
        >
          <div fxFlex="grow" class="section-header">
            Company Registration Details
          </div>
          <div fxLayout="row" fxLayoutGap="10px">
            <!-- <span
              class="square"
              *ngIf="rcStatus === 'EMPTY'"
              [ngClass]="{
                'border-greyBlank': rcStatus == 'EMPTY',
                'border-grey':
                  rcStatus == 'NOT_AVAILABLE' &&
                  companyDetail &&
                  !companyDetail.companyRegVerified,
                'border-green':
                  rcStatus == 'VERIFIED' ||
                  (companyDetail && companyDetail.companyRegVerified),
                'border-red':
                  rcStatus == 'REJECTED' || rcStatus == 'UNVERIFIED',
                'border-orange': rcStatus == 'PENDING'
              }"
            >
              <label
                class="ui empty circular label"
                [ngClass]="{
                  'label-greyBlank': rcStatus == 'EMPTY',
                  'label-grey':
                    rcStatus == 'NOT_AVAILABLE' &&
                    companyDetail &&
                    !companyDetail.companyRegVerified,
                  'label-green':
                    rcStatus == 'VERIFIED' ||
                    (companyDetail && companyDetail.companyRegVerified),
                  'label-red':
                    rcStatus == 'REJECTED' || rcStatus == 'UNVERIFIED',
                  'label-orange': rcStatus == 'PENDING'
                }"
              ></label>
            </span>
            <span
              class="square"
              *ngIf="rcStatus !== 'EMPTY'"
              suiPopup
              [popupInverted]="true"
              popupPlacement="bottom"
              popupText="{{ getStatusName(rcStatus) }}"
              style="cursor: pointer"
              [ngClass]="{
                'border-greyBlank': rcStatus == 'EMPTY',
                'border-grey':
                  rcStatus == 'NOT_AVAILABLE' &&
                  companyDetail &&
                  !companyDetail.companyRegVerified,
                'border-green':
                  rcStatus == 'VERIFIED' ||
                  (companyDetail && companyDetail.companyRegVerified),
                'border-red':
                  rcStatus == 'REJECTED' || rcStatus == 'UNVERIFIED',
                'border-orange': rcStatus == 'PENDING'
              }"
            >
              <label
                class="ui empty circular label"
                [ngClass]="{
                  'label-greyBlank': rcStatus == 'EMPTY',
                  'label-grey':
                    rcStatus == 'NOT_AVAILABLE' &&
                    companyDetail &&
                    !companyDetail.companyRegVerified,
                  'label-green':
                    rcStatus == 'VERIFIED' ||
                    (companyDetail && companyDetail.companyRegVerified),
                  'label-red':
                    rcStatus == 'REJECTED' || rcStatus == 'UNVERIFIED',
                  'label-orange': rcStatus == 'PENDING'
                }"
              ></label>
            </span> -->
            <div
              [ngClass]="{
                'label-greyBlank': rcStatus == 'EMPTY',
                'label-grey':
                  rcStatus == 'NOT_AVAILABLE' &&
                  companyDetail &&
                  !companyDetail.companyRegVerified,
                'label-green':
                  rcStatus == 'VERIFIED' ||
                  (companyDetail && companyDetail.companyRegVerified),
                'label-red': rcStatus == 'REJECTED' || rcStatus == 'UNVERIFIED',
                'label-orange': rcStatus == 'PENDING'
              }"
              class="ui tiny circular label"
              style="
                height: 20px !important;
                padding: 0 10px !important;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                font-weight: 400;
                white-space: nowrap;
              "
            >
              {{
                rcStatus == "PENDING"
                  ? "PENDING VERIFICATION"
                  : rcStatus == "FAILED"
                  ? "FAILED VERIFICATION"
                  : rcStatus == "UNVERIFIED"
                  ? "UNVERIFIED"
                  : rcStatus == "VERIFIED"
                  ? "VERIFIED"
                  : rcStatus
              }}
            </div>
            <button
              suiPopup
              [popupInverted]="true"
              popupPlacement="bottom"
              popupText="View History"
              (click)="viewHistory('RC_NUMBER')"
              class="ui tiny button"
            >
              <img
                style="position: relative; right: 0.7em; bottom: 0.1rem"
                src="/assets/icons/Group 416.svg"
              />
            </button>
            <button
              *ngIf="rcStatus !== 'VERIFIED'"
              suiPopup
              [popupInverted]="true"
              popupPlacement="bottom"
              popupText="Request Edit"
              style="margin-right: 0px"
              (click)="editDetail('RC_NUMBER')"
              class="ui tiny button not_tiny"
            >
              <img
                style="position: relative; right: 0.5em; bottom: 0.1rem"
                src="/assets/icons/pen.svg"
              />
            </button>
          </div>
          <div
            *ngIf="rcStatus == 'PENDING'"
            class="ui message"
            style="
              background-color: #fff2e2;
              display: flex;
              width: 389px;
              position: absolute;
              right: 0;
              padding: 2px 4px 2px 4px;
              top: 1.6rem;
              margin-top: 2.4rem;
            "
          >
            <h6 style="font-size: 10px; font-weight: 400; color: #505050">
              <span
                style="
                  margin-right: 9px;
                  margin-left: 5px;
                  vertical-align: middle;
                "
                ><svg
                  width="12"
                  height="11"
                  viewBox="0 0 12 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.99915 4.7507V6.6257M1.34753 8.31352C0.914839 9.06352 1.45612 10.0007 2.32199 10.0007H9.67632C10.5422 10.0007 11.0835 9.06352 10.6508 8.31352L6.97361 1.93977C6.54068 1.18935 5.45763 1.18935 5.02469 1.93977L1.34753 8.31352ZM5.99915 8.1257H6.0029V8.12945H5.99915V8.1257Z"
                    stroke="#505050"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  /></svg></span
              >The details you've submitted for verification will be visible
              upon NCC's approval.
            </h6>
          </div>
        </div>
        <div class="ui divider"></div>
        <form class="ui form" appMargin marginT="20px">
          <div class="required field" appMargin marginB="15px">
            <!-- <label>RC Number</label>
            <div class="ui input">
              <input
                type="text"
                [value]="organization?.jpaContractor?.rcNumber"
                disabled
              />
            </div> -->
            <h6 style="font-size: 12px; color: #00000066; font-weight: 400">
              RC Number <span style="color: red">*</span>
            </h6>
            <h4 style="margin-top: -1rem; color: #505050">
              {{ organization?.jpaContractor?.rcNumber || "--" }}
            </h4>
          </div>
          <div class="ui divider"></div>
          <div class="required field" appMargin marginB="15px">
            <!-- <label>Company Type</label>
            <div class="ui input">
              <input
                type="text"
                [value]="organization?.jpaContractor?.companyType?.optionName"
                disabled
              />
            </div> -->
            <h6 style="font-size: 12px; color: #00000066; font-weight: 400">
              Company Type <span style="color: red">*</span>
            </h6>
            <h4 style="margin-top: -1rem; color: #505050">
              {{ organization?.jpaContractor?.companyType?.optionName || "--" }}
            </h4>
          </div>
          <div class="ui divider"></div>
          <div class="required field" appMargin marginB="15px">
            <!-- <label>Ownership Type</label>
            <div class="ui input">
              <input
                type="text"
                [value]="organization?.jpaContractor?.ownershipType?.optionName"
                disabled
              />
            </div> -->
            <h6 style="font-size: 12px; color: #00000066; font-weight: 400">
              Ownership Type <span style="color: red">*</span>
            </h6>
            <h4 style="margin-top: -1rem; color: #505050">
              {{
                organization?.jpaContractor?.ownershipType?.optionName || "--"
              }}
            </h4>
          </div>
          <div class="ui divider"></div>
          <div class="required field" appMargin marginB="15px">
            <!-- <label>Registration Date</label>
            <div class="ui input">
              <input
                type=""
                name="date"
                [ngModel]="
                  organization?.jpaContractor?.dateOfRegistration
                    | date: 'mediumDate'
                "
                disabled
              />
            </div> -->
            <h6 style="font-size: 12px; color: #00000066; font-weight: 400">
              Registration Date <span style="color: red">*</span>
            </h6>
            <h4 style="margin-top: -1rem; color: #505050">
              {{
                (organization?.jpaContractor?.dateOfRegistration
                  | date: "mediumDate") || "--"
              }}
            </h4>
          </div>
        </form>
        <div class="ui divider"></div>
      </div>

      <div class="ui segment" id="tin" style="padding-right: 0px">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div fxFlex="grow" class="section-header">Company TIN</div>
          <ng-container *ngIf="!isBusinessName">
            <div
              fxLayout="column"
              fxLayoutAlign="center end"
              fxLayoutGap="12px"
            >
              <div fxLayout="row" fxLayoutGap="10px">
                <div
                  [ngClass]="{
                    'label-greyBlank': tinStatus == 'EMPTY',
                    'label-grey':
                      tinStatus == 'NOT_AVAILABLE' &&
                      companyDetail &&
                      !companyDetail.companyRegVerified,
                    'label-green':
                      tinStatus == 'VERIFIED' ||
                      (companyDetail && companyDetail.companyRegVerified),
                    'label-red':
                      tinStatus == 'REJECTED' || tinStatus == 'UNVERIFIED',
                    'label-orange': tinStatus == 'PENDING'
                  }"
                  class="ui tiny circular label"
                  style="
                    height: 20px !important;
                    padding: 0 10px !important;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 400;
                    white-space: nowrap;
                  "
                >
                  {{
                    tinStatus == "PENDING"
                      ? "PENDING VERIFICATION"
                      : tinStatus == "FAILED"
                      ? "FAILED VERIFICATION"
                      : tinStatus == "UNVERIFIED"
                      ? "UNVERIFIED"
                      : tinStatus == "VERIFIED"
                      ? "VERIFIED"
                      : tinStatus
                  }}
                </div>
                <button
                  suiPopup
                  [popupInverted]="true"
                  popupPlacement="bottom"
                  popupText="View History"
                  (click)="viewHistory('TIN')"
                  class="ui tiny button"
                >
                  <img
                    style="position: relative; right: 0.7em; bottom: 0.1rem"
                    src="/assets/icons/Group 416.svg"
                  />
                </button>

                <button
                  suiPopup
                  *ngIf="tinStatus !== 'VERIFIED'"
                  [popupInverted]="true"
                  popupPlacement="bottom"
                  popupText="Request Edit"
                  style="margin-right: 0px"
                  (click)="editDetail('TIN')"
                  class="ui tiny button not_tiny"
                >
                  <img
                    style="position: relative; right: 0.5em; bottom: 0.1rem"
                    src="/assets/icons/pen.svg"
                  />
                </button>
                <button
                  *ngIf="tinStatus == 'UNVERIFIED' && isBusinessName"
                  suiPopup
                  [popupInverted]="true"
                  popupPlacement="bottom"
                  popupText="Add FIRS TIN"
                  class="ui tiny button"
                  (click)="newRecord('TIN')"
                >
                  <img
                    src="../../../../../../assets/icons/plus icon.svg"
                    alt=""
                  />
                </button>
              </div>
              <div
                *ngIf="tinStatus == 'PENDING'"
                class="ui message"
                style="
                  background-color: #fff2e2;
                  display: flex;
                  width: max-content;
                  padding: 2px 4px 2px 4px;
                  margin-top: 0;
                "
              >
                <h6 style="font-size: 10px; font-weight: 400; color: #505050">
                  <span
                    style="
                      margin-right: 9px;
                      margin-left: 5px;
                      vertical-align: middle;
                    "
                    ><svg
                      width="12"
                      height="11"
                      viewBox="0 0 12 11"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.99915 4.7507V6.6257M1.34753 8.31352C0.914839 9.06352 1.45612 10.0007 2.32199 10.0007H9.67632C10.5422 10.0007 11.0835 9.06352 10.6508 8.31352L6.97361 1.93977C6.54068 1.18935 5.45763 1.18935 5.02469 1.93977L1.34753 8.31352ZM5.99915 8.1257H6.0029V8.12945H5.99915V8.1257Z"
                        stroke="#505050"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      /></svg></span
                  >The details you've submitted for verification will be visible
                  upon NCC's approval.
                </h6>
              </div>
              <div
                *ngIf="tinStatus == 'UNVERIFIED'"
                class="ui message"
                style="
                  background-color: #fff0f0;
                  display: flex;
                  width: max-content;
                  padding: 2px 4px 2px 4px;
                  margin-top: 0;
                "
              >
                <h6 style="font-size: 10px; font-weight: 400; color: #505050">
                  <span
                    style="
                      margin-right: 9px;
                      margin-left: 5px;
                      vertical-align: middle;
                    "
                    ><svg
                      width="12"
                      height="11"
                      viewBox="0 0 12 11"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.99915 4.7507V6.6257M1.34753 8.31352C0.914839 9.06352 1.45612 10.0007 2.32199 10.0007H9.67632C10.5422 10.0007 11.0835 9.06352 10.6508 8.31352L6.97361 1.93977C6.54068 1.18935 5.45763 1.18935 5.02469 1.93977L1.34753 8.31352ZM5.99915 8.1257H6.0029V8.12945H5.99915V8.1257Z"
                        stroke="#505050"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      /></svg></span
                  >Please provide the accurate TIN for your company.
                </h6>
              </div>
            </div>
          </ng-container>
          <div
            *ngIf="isBusinessName"
            fxLayout="row"
            class="text-right"
            style="text-wrap: nowrap"
          >
            <a
              style="cursor: pointer"
              *ngIf="tinStatus === 'UNVERIFIED'"
              (click)="newRecord('TIN')"
            >
              Add FIRS TIN
            </a>
          </div>
        </div>
        <div class="ui divider"></div>
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div fxFlex="grow">
            <form class="ui form">
              <ng-container *ngIf="isBusinessName">
                <div
                  fxLayout="row"
                  fxLayoutAlign="space-between center"
                  class="required field"
                  appMargin
                  marginB="15px"
                >
                  <div>
                    <h6
                      style="
                        font-size: 12px;
                        color: #00000066;
                        font-weight: 400;
                      "
                    >
                      Other Tax Identification Number
                      <span style="color: red">*</span>
                    </h6>
                    <h4 style="margin-top: -1rem; color: #505050">
                      {{ organization?.jpaContractor?.otherTinNumber || "--" }}
                    </h4>
                  </div>
                  <!-- <ng-container *ngIf="otherTinStatus == 'NOT_AVAILABLE'"> -->
                  <div fxLayout="column" fxLayoutAlign="center end">
                    <div fxLayout="row" fxLayoutGap="10px">
                      <div
                        [ngClass]="{
                          'label-greyBlank': otherTinStatus == 'EMPTY',
                          'label-grey':
                            otherTinStatus == 'NOT_AVAILABLE' ||
                            (companyDetail &&
                              !companyDetail.companyRegVerified),
                          'label-green':
                            otherTinStatus == 'VERIFIED' ||
                            (companyDetail && companyDetail.companyRegVerified),
                          'label-red':
                            otherTinStatus == 'REJECTED' ||
                            otherTinStatus == 'UNVERIFIED',
                          'label-orange': otherTinStatus == 'PENDING'
                        }"
                        class="ui tiny circular label"
                        style="
                          height: 20px !important;
                          padding: 0 10px !important;
                          display: inline-flex;
                          align-items: center;
                          justify-content: center;
                          font-weight: 400;
                          white-space: nowrap;
                        "
                      >
                        {{
                          otherTinStatus == "PENDING"
                            ? "PENDING VERIFICATION"
                            : otherTinStatus == "FAILED"
                            ? "FAILED VERIFICATION"
                            : otherTinStatus == "UNVERIFIED"
                            ? "UNVERIFIED"
                            : otherTinStatus == "VERIFIED"
                            ? "VERIFIED"
                            : otherTinStatus
                        }}
                      </div>
                      <button
                        suiPopup
                        [popupInverted]="true"
                        popupPlacement="bottom"
                        popupText="View History"
                        (click)="viewHistory('OTHER_TIN')"
                        class="ui tiny button"
                      >
                        <img
                          style="
                            position: relative;
                            right: 0.7em;
                            bottom: 0.1rem;
                          "
                          src="/assets/icons/Group 416.svg"
                        />
                      </button>
                      <button
                        *ngIf="otherTinStatus !== 'VERIFIED'"
                        suiPopup
                        [popupInverted]="true"
                        popupPlacement="bottom"
                        popupText="Request Edit"
                        style="margin-right: 0px"
                        (click)="editDetail('OTHER_TIN')"
                        class="ui tiny button not_tiny"
                      >
                        <img
                          style="
                            position: relative;
                            right: 0.5em;
                            bottom: 0.1rem;
                          "
                          src="/assets/icons/pen.svg"
                        />
                      </button>
                      <!-- <button
                          *ngIf="otherTinStatus == 'NOT_AVAILABLE'"
                          suiPopup
                          [popupInverted]="true"
                          popupPlacement="bottom"
                          popupText="Add Other TIN"
                          class="ui tiny button"
                        >
                          <img src="../../../../../../assets/icons/plus icon.svg" alt="" />
                        </button> -->
                    </div>
                    <div
                      *ngIf="otherTinStatus == 'PENDING'"
                      class="ui message"
                      style="
                        background-color: #fff2e2;
                        display: flex;
                        width: max-content;
                        padding: 2px 4px 2px 4px;
                      "
                    >
                      <h6
                        style="
                          font-size: 10px;
                          font-weight: 400;
                          color: #505050;
                        "
                      >
                        <span
                          style="
                            margin-right: 9px;
                            margin-left: 5px;
                            vertical-align: middle;
                          "
                          ><svg
                            width="12"
                            height="11"
                            viewBox="0 0 12 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5.99915 4.7507V6.6257M1.34753 8.31352C0.914839 9.06352 1.45612 10.0007 2.32199 10.0007H9.67632C10.5422 10.0007 11.0835 9.06352 10.6508 8.31352L6.97361 1.93977C6.54068 1.18935 5.45763 1.18935 5.02469 1.93977L1.34753 8.31352ZM5.99915 8.1257H6.0029V8.12945H5.99915V8.1257Z"
                              stroke="#505050"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            /></svg></span
                        >The details you've submitted for verification will be
                        visible upon NCC's approval.
                      </h6>
                    </div>
                    <div
                      *ngIf="
                        otherTinStatus == 'REJECTED' ||
                        otherTinStatus == 'UNVERIFIED'
                      "
                      class="ui message"
                      style="
                        background-color: #fff0f0;
                        display: flex;
                        width: max-content;
                        padding: 2px 4px 2px 4px;
                      "
                    >
                      <h6
                        style="
                          font-size: 10px;
                          font-weight: 400;
                          color: #505050;
                        "
                      >
                        <span
                          style="
                            margin-right: 9px;
                            margin-left: 5px;
                            vertical-align: middle;
                          "
                          ><svg
                            width="12"
                            height="11"
                            viewBox="0 0 12 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5.99915 4.7507V6.6257M1.34753 8.31352C0.914839 9.06352 1.45612 10.0007 2.32199 10.0007H9.67632C10.5422 10.0007 11.0835 9.06352 10.6508 8.31352L6.97361 1.93977C6.54068 1.18935 5.45763 1.18935 5.02469 1.93977L1.34753 8.31352ZM5.99915 8.1257H6.0029V8.12945H5.99915V8.1257Z"
                              stroke="#505050"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            /></svg></span
                        >Please provide the accurate TIN for your company.
                      </h6>
                    </div>
                  </div>
                  <!-- </ng-container> -->
                </div>

                <div *ngIf="tinStatus == 'UNVERIFIED'" class="ui divider"></div>
              </ng-container>

              <div
                *ngIf="tinStatus === 'VERIFIED' || tinStatus === 'PENDING'"
                fxLayout="row"
                fxLayoutAlign="space-between center"
                class="required field"
                appMargin
                marginB="15px"
              >
                <div>
                  <h6
                    style="font-size: 12px; color: #00000066; font-weight: 400"
                  >
                    FIRS Tax Identification Number
                    <span style="color: red">*</span>
                  </h6>
                  <h4 style="margin-top: -1rem; color: #505050">
                    {{ organization?.jpaContractor?.tinNumber || "--" }}
                  </h4>
                </div>
                <ng-container *ngIf="isBusinessName">
                  <div fxLayout="column" fxLayoutAlign="center end">
                    <div fxLayout="row" fxLayoutGap="10px">
                      <div
                        [ngClass]="{
                          'label-greyBlank': tinStatus == 'EMPTY',
                          'label-grey':
                            tinStatus == 'NOT_AVAILABLE' ||
                            (companyDetail &&
                              !companyDetail.companyRegVerified),
                          'label-green':
                            tinStatus == 'VERIFIED' ||
                            (companyDetail && companyDetail.companyRegVerified),
                          'label-red':
                            tinStatus == 'REJECTED' ||
                            tinStatus == 'UNVERIFIED',
                          'label-orange': tinStatus == 'PENDING'
                        }"
                        class="ui tiny circular label"
                        style="
                          height: 20px !important;
                          padding: 0 10px !important;
                          display: inline-flex;
                          align-items: center;
                          justify-content: center;
                          font-weight: 400;
                          white-space: nowrap;
                        "
                      >
                        {{
                          tinStatus == "PENDING"
                            ? "PENDING VERIFICATION"
                            : tinStatus == "FAILED"
                            ? "FAILED VERIFICATION"
                            : tinStatus == "UNVERIFIED"
                            ? "UNVERIFIED"
                            : tinStatus == "VERIFIED"
                            ? "VERIFIED"
                            : tinStatus
                        }}
                      </div>
                      <button
                        suiPopup
                        [popupInverted]="true"
                        popupPlacement="bottom"
                        popupText="View History"
                        (click)="viewHistory('TIN')"
                        class="ui tiny button"
                      >
                        <img
                          style="
                            position: relative;
                            right: 0.7em;
                            bottom: 0.1rem;
                          "
                          src="/assets/icons/Group 416.svg"
                        />
                      </button>
                      <button
                        *ngIf="tinStatus !== 'VERIFIED'"
                        suiPopup
                        [popupInverted]="true"
                        popupPlacement="bottom"
                        popupText="Request Edit"
                        style="margin-right: 0px"
                        (click)="editDetail('TIN')"
                        class="ui tiny button not_tiny"
                      >
                        <img
                          style="
                            position: relative;
                            right: 0.5em;
                            bottom: 0.1rem;
                          "
                          src="/assets/icons/pen.svg"
                        />
                      </button>
                      <!-- <button
                        *ngIf="tinStatus !== 'VERIFIED'"
                        suiPopup
                        [popupInverted]="true"
                        popupPlacement="bottom"
                        popupText="Add FIRS TIN"
                        class="ui tiny button"
                        (click)="newRecord('TIN')"
                      >
                        <img
                          src="../../../../../../assets/icons/plus icon.svg"
                          alt=""
                        />
                      </button> -->
                    </div>
                    <div
                      *ngIf="tinStatus == 'PENDING'"
                      class="ui message"
                      style="
                        background-color: #fff2e2;
                        display: flex;
                        width: max-content;
                        padding: 2px 4px 2px 4px;
                      "
                    >
                      <h6
                        style="
                          font-size: 10px;
                          font-weight: 400;
                          color: #505050;
                        "
                      >
                        <span
                          style="
                            margin-right: 9px;
                            margin-left: 5px;
                            vertical-align: middle;
                          "
                          ><svg
                            width="12"
                            height="11"
                            viewBox="0 0 12 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5.99915 4.7507V6.6257M1.34753 8.31352C0.914839 9.06352 1.45612 10.0007 2.32199 10.0007H9.67632C10.5422 10.0007 11.0835 9.06352 10.6508 8.31352L6.97361 1.93977C6.54068 1.18935 5.45763 1.18935 5.02469 1.93977L1.34753 8.31352ZM5.99915 8.1257H6.0029V8.12945H5.99915V8.1257Z"
                              stroke="#505050"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            /></svg></span
                        >The details you've submitted for verification will be
                        visible upon NCC's approval.
                      </h6>
                    </div>
                    <div
                      *ngIf="
                        tinStatus == 'REJECTED' || tinStatus == 'UNVERIFIED'
                      "
                      class="ui message"
                      style="
                        background-color: #fff0f0;
                        display: flex;
                        width: max-content;
                        padding: 2px 4px 2px 4px;
                      "
                    >
                      <h6
                        style="
                          font-size: 10px;
                          font-weight: 400;
                          color: #505050;
                        "
                      >
                        <span
                          style="
                            margin-right: 9px;
                            margin-left: 5px;
                            vertical-align: middle;
                          "
                          ><svg
                            width="12"
                            height="11"
                            viewBox="0 0 12 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5.99915 4.7507V6.6257M1.34753 8.31352C0.914839 9.06352 1.45612 10.0007 2.32199 10.0007H9.67632C10.5422 10.0007 11.0835 9.06352 10.6508 8.31352L6.97361 1.93977C6.54068 1.18935 5.45763 1.18935 5.02469 1.93977L1.34753 8.31352ZM5.99915 8.1257H6.0029V8.12945H5.99915V8.1257Z"
                              stroke="#505050"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            /></svg></span
                        >Please provide the accurate TIN for your company.
                      </h6>
                    </div>
                  </div>
                </ng-container>
              </div>
              <!-- <div class="ui divider"></div> -->
            </form>
          </div>

          <!-- <div
						*ngIf="tinStatus == 'PENDING'"
						class="ui message"
						style="
							background-color: #fff2e2;
							display: flex;
							width: 389px;
							position: absolute;
							right: 0;
							padding: 2px 4px 2px 4px;
							top: 1.6rem;
							margin-top: 2.4rem;
						"
					>
						<h6 style="font-size: 10px; font-weight: 400; color: #505050;">
							<span style="margin-right: 9px; margin-left: 5px; vertical-align: middle;"
								><svg
									width="12"
									height="11"
									viewBox="0 0 12 11"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M5.99915 4.7507V6.6257M1.34753 8.31352C0.914839 9.06352 1.45612 10.0007 2.32199 10.0007H9.67632C10.5422 10.0007 11.0835 9.06352 10.6508 8.31352L6.97361 1.93977C6.54068 1.18935 5.45763 1.18935 5.02469 1.93977L1.34753 8.31352ZM5.99915 8.1257H6.0029V8.12945H5.99915V8.1257Z"
										stroke="#505050"
										stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round"
									/></svg></span
							>The details you've submitted for verification will be visible
							upon NCC's approval.
						</h6>
					</div> -->
        </div>
        <div class="ui divider"></div>
      </div>

      <div class="ui segment" id="address" style="padding-right: 0px">
        <div
          style="margin-bottom: 3rem"
          fxLayout="row"
          fxLayoutAlign="space-between center"
        >
          <div fxFlex="grow" class="section-header">Company Address</div>
          <div fxLayout="row" fxLayoutGap="10px">
            <div
              [ngClass]="{
                'label-greyBlank': addressStatus == 'EMPTY',
                'label-grey':
                  addressStatus == 'NOT_AVAILABLE' &&
                  companyDetail &&
                  !companyDetail.companyRegVerified,
                'label-green':
                  addressStatus == 'VERIFIED' ||
                  (companyDetail && companyDetail.companyRegVerified),
                'label-red':
                  addressStatus == 'REJECTED' || addressStatus == 'UNVERIFIED',
                'label-orange': addressStatus == 'PENDING'
              }"
              class="ui tiny circular label"
              style="
                height: 20px !important;
                padding: 0 10px !important;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                font-weight: 400;
                white-space: nowrap;
              "
            >
              {{
                addressStatus == "PENDING"
                  ? "PENDING VERIFICATION"
                  : addressStatus == "FAILED"
                  ? "FAILED VERIFICATION"
                  : addressStatus == "UNVERIFIED"
                  ? "UNVERIFIED"
                  : addressStatus == "VERIFIED"
                  ? "VERIFIED"
                  : addressStatus
              }}
            </div>
            <button
              suiPopup
              [popupInverted]="true"
              popupPlacement="bottom"
              popupText="View History"
              (click)="viewHistory('ADDRESS')"
              class="ui tiny button"
            >
              <img
                style="position: relative; right: 0.7em; bottom: 0.1rem"
                src="/assets/icons/Group 416.svg"
              />
            </button>
            <button
              suiPopup
              [popupInverted]="true"
              popupPlacement="bottom"
              popupText="Edit Address Details"
              (click)="editDetail('ADDRESS')"
              class="ui tiny button"
            >
              <img
                style="position: relative; right: 0.5em; bottom: 0.1rem"
                src="/assets/icons/pen.svg"
              />
            </button>
          </div>
          <div
            *ngIf="addressStatus == 'PENDING'"
            class="ui message"
            style="
              background-color: #fff2e2;
              display: flex;
              width: 389px;
              position: absolute;
              right: 0;
              padding: 2px 4px 2px 4px;
              top: 1.6rem;
              margin-top: 2.4rem;
            "
          >
            <h6 style="font-size: 10px; font-weight: 400; color: #505050">
              <span
                style="
                  margin-right: 9px;
                  margin-left: 5px;
                  vertical-align: middle;
                "
                ><svg
                  width="12"
                  height="11"
                  viewBox="0 0 12 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.99915 4.7507V6.6257M1.34753 8.31352C0.914839 9.06352 1.45612 10.0007 2.32199 10.0007H9.67632C10.5422 10.0007 11.0835 9.06352 10.6508 8.31352L6.97361 1.93977C6.54068 1.18935 5.45763 1.18935 5.02469 1.93977L1.34753 8.31352ZM5.99915 8.1257H6.0029V8.12945H5.99915V8.1257Z"
                    stroke="#505050"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  /></svg></span
              >The details you've submitted for verification will be visible
              upon NCC's approval.
            </h6>
          </div>
        </div>

        <div class="ui divider"></div>
        <form class="ui form" appMargin marginT="20px">
          <div class="required field" appMargin marginB="15px">
            <h6 style="font-size: 12px; color: #00000066; font-weight: 400">
              Street <span style="color: red">*</span>
            </h6>
            <h4 style="margin-top: -1rem; color: #505050">
              {{ organization?.jpaContractor?.headOfficeAddressStreet || "--" }}
            </h4>
          </div>
          <div class="ui divider"></div>

          <div class="required field" appMargin marginB="15px">
            <!-- <label>Area/City</label>
            <div class="ui input">
              <input
                type="text"
                [value]="organization?.jpaContractor?.headOfficeAddressCity"
                disabled
              />
            </div> -->
            <h6 style="font-size: 12px; color: #00000066; font-weight: 400">
              Area/City <span style="color: red">*</span>
            </h6>
            <h4 style="margin-top: -1rem; color: #505050">
              {{ organization?.jpaContractor?.headOfficeAddressCity || "--" }}
            </h4>
          </div>
          <div class="ui divider"></div>

          <div class="required field" appMargin marginB="15px">
            <!-- <label>State</label>
            <div class="ui input">
              <input
                type="text"
                [value]="
                  organization?.jpaContractor?.headOfficeAddressState?.stateName
                "
                disabled
              />
            </div> -->

            <h6 style="font-size: 12px; color: #00000066; font-weight: 400">
              State <span style="color: red">*</span>
            </h6>
            <h4 style="margin-top: -1rem; color: #505050">
              {{
                organization?.jpaContractor?.headOfficeAddressState
                  ?.stateName || "--"
              }}
            </h4>
          </div>
          <div class="ui divider"></div>
          <div class="required field" appMargin marginB="15px">
            <!-- <label>Zip Code</label>
            <div class="ui input">
              <input
                type="text"
                [value]="organization?.jpaContractor?.headOfficeAddressZip"
                disabled
              />
            </div> -->
            <h6 style="font-size: 12px; color: #00000066; font-weight: 400">
              Zip Code <span style="color: red">*</span>
            </h6>
            <h4 style="margin-top: -1rem; color: #505050">
              {{ organization?.jpaContractor?.headOfficeAddressZip || "--" }}
            </h4>
          </div>
          <div class="ui divider"></div>
          <div class="required field" appMargin marginB="15px">
            <!-- <label>Country</label>
            <div class="ui input">
              <input
                type="text"
                [value]="
                  organization?.jpaContractor?.countryOfRegistration
                    ?.countryName
                "
                disabled
              />
            </div> -->
            <h6 style="font-size: 12px; color: #00000066; font-weight: 400">
              Country <span style="color: red">*</span>
            </h6>
            <h4 style="margin-top: -1rem; color: #505050">
              {{
                organization?.jpaContractor?.countryOfRegistration
                  ?.countryName || "--"
              }}
            </h4>
          </div>
          <div class="ui divider"></div>
        </form>
      </div>

      <div class="ui segment" style="padding-right: 0px">
        <div
          fxLayout="row"
          style="margin-bottom: 3rem !important"
          fxLayoutAlign="space-between center"
        >
          <div fxFlex="grow" class="section-header">
            Company Contact Information
          </div>
          <div fxLayout="row" fxLayoutGap="10px">
            <!-- <span
              *ngIf="contactStatus === 'EMPTY'"
              class="square"
              [ngClass]="{
                'border-greyBlank': contactStatus == 'EMPTY',
                'border-grey': contactStatus == 'NOT_AVAILABLE',
                'border-green': contactStatus == 'VERIFIED',
                'border-red':
                  contactStatus == 'REJECTED' || contactStatus == 'UNVERIFIED',
                'border-orange': contactStatus == 'PENDING'
              }"
            >
              <label
                class="ui empty circular label"
                [ngClass]="{
                  'label-greyBlank': contactStatus == 'EMPTY',
                  'label-grey': contactStatus == 'NOT_AVAILABLE',
                  'label-green': contactStatus == 'VERIFIED',
                  'label-red':
                    contactStatus == 'REJECTED' ||
                    contactStatus == 'UNVERIFIED',
                  'label-orange': contactStatus == 'PENDING'
                }"
              ></label>
            </span>
            <span
              *ngIf="contactStatus !== 'EMPTY'"
              class="square"
              suiPopup
              [popupInverted]="true"
              popupPlacement="bottom"
              popupText="{{ contactStatus }}"
              style="cursor: pointer"
              [ngClass]="{
                'border-greyBlank': contactStatus == 'EMPTY',
                'border-grey': contactStatus == 'NOT_AVAILABLE',
                'border-green': contactStatus == 'VERIFIED',
                'border-red':
                  contactStatus == 'REJECTED' || contactStatus == 'UNVERIFIED',
                'border-orange': contactStatus == 'PENDING'
              }"
            >
              <label
                class="ui empty circular label"
                [ngClass]="{
                  'label-greyBlank': contactStatus == 'EMPTY',
                  'label-grey': contactStatus == 'NOT_AVAILABLE',
                  'label-green': contactStatus == 'VERIFIED',
                  'label-red':
                    contactStatus == 'REJECTED' ||
                    contactStatus == 'UNVERIFIED',
                  'label-orange': contactStatus == 'PENDING'
                }"
              ></label>
            </span>
            <button
              appMargin
              marginX="10px"
              suiPopup
              [popupInverted]="true"
              popupPlacement="bottom"
              popupText="View History"
              (click)="viewHistory('CONTACT_INFORMATION')"
              class="ui tiny button"
            >
              <img src="./assets/icons/eye.svg" alt="" />
            </button>
            <button
              suiPopup
              [popupInverted]="true"
              popupPlacement="bottom"
              popupText="Request Edit"
              (click)="editDetail('CONTACT_INFORMATION')"
              class="ui tiny button"
            >
              <img src="./assets/icons/pen.svg" alt="" />
            </button> -->
            <!-- <div
              [ngClass]="{
                'label-greyBlank': contactStatus == 'EMPTY',
                'label-grey':
                  contactStatus == 'NOT_AVAILABLE' &&
                  companyDetail &&
                  !companyDetail.companyRegVerified,
                'label-green':
                  contactStatus == 'VERIFIED' ||
                  (companyDetail && companyDetail.companyRegVerified),
                'label-red':
                  contactStatus == 'REJECTED' || contactStatus == 'UNVERIFIED',
                'label-orange': contactStatus == 'PENDING'
              }"
              class="ui tiny circular label"
              style="
                height: 20px !important;
                padding: 0 10px !important;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                font-weight: 400;
                white-space: nowrap;
              "
            >
              {{
                contactStatus == "PENDING"
                  ? "PENDING VERIFICATION"
                  : contactStatus == "FAILED"
                  ? "FAILED VERIFICATION"
                  : contactStatus == "UNVERIFIED"
                  ? "UNVERIFIED"
                  : contactStatus == "VERIFIED"
                  ? "VERIFIED"
                  : contactStatus
              }}
            </div> -->
            <!-- <button
              suiPopup
              [popupInverted]="true"
              popupPlacement="bottom"
              popupText="View History"
              (click)="viewHistory('CONTACT_INFORMATION')"
              class="ui tiny button"
            >
              <img
                style="position: relative; right: 0.7em; bottom: 0.1rem"
                src="/assets/icons/Group 416.svg"
              />
            </button> -->
            <button
              suiPopup
              [popupInverted]="true"
              popupPlacement="bottom"
              popupText="Request Edit"
              style="margin-right: 0px"
              (click)="editDetail('CONTACT_INFORMATION')"
              class="ui tiny button not_tiny"
            >
              <img
                style="position: relative; right: 0.5em; bottom: 0.1rem"
                src="/assets/icons/pen.svg"
              />
            </button>
          </div>
          <!-- <div
            *ngIf="contactStatus == 'PENDING'"
            class="ui message"
            style="
              background-color: #fff2e2;
              display: flex;
              width: 389px;
              position: absolute;
              right: 0;
              padding: 2px 4px 2px 4px;
              top: 1.6rem;
              margin-top: 2.4rem;
            "
          >
            <h6 style="font-size: 10px; font-weight: 400; color: #505050">
              <span
                style="
                  margin-right: 9px;
                  margin-left: 5px;
                  vertical-align: middle;
                "
                ><svg
                  width="12"
                  height="11"
                  viewBox="0 0 12 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.99915 4.7507V6.6257M1.34753 8.31352C0.914839 9.06352 1.45612 10.0007 2.32199 10.0007H9.67632C10.5422 10.0007 11.0835 9.06352 10.6508 8.31352L6.97361 1.93977C6.54068 1.18935 5.45763 1.18935 5.02469 1.93977L1.34753 8.31352ZM5.99915 8.1257H6.0029V8.12945H5.99915V8.1257Z"
                    stroke="#505050"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  /></svg></span
              >The details you've submitted for verification will be visible
              upon NCC's approval.
            </h6>
          </div> -->
        </div>
        <div class="ui divider"></div>

        <form class="ui form" appMargin marginT="20px">
          <div class="required field" appMargin marginB="15px">
            <!-- <label>Email Address</label>
            <div class="ui input">
              <input
                type="text"
                [value]="organization?.jpaContractor?.companyContactEmail"
                disabled
              />
            </div> -->
            <h6 style="font-size: 12px; color: #00000066; font-weight: 400">
              Email Address <span style="color: red">*</span>
            </h6>
            <h4 style="margin-top: -1rem; color: #505050">
              {{ organization?.jpaContractor?.companyContactEmail || "--" }}
            </h4>
          </div>
          <div class="ui divider"></div>
          <div class="required field" appMargin marginB="15px">
            <!-- <label>Alternative Email Address</label>
            <div class="ui input">
              <input
                type="text"
                [value]="
                  organization?.jpaContractor?.companyContactAlternativeEmail
                "
                disabled
              />
            </div> -->
            <h6 style="font-size: 12px; color: #00000066; font-weight: 400">
              Alternative Email Address <span style="color: red">*</span>
            </h6>
            <h4 style="margin-top: -1rem; color: #505050">
              {{
                organization?.jpaContractor?.companyContactAlternativeEmail ||
                  "--"
              }}
            </h4>
          </div>
          <div class="ui divider"></div>

          <div class="required field" appMargin marginB="15px">
            <!-- <label>Phone Number</label>
            <div class="ui input">
              <input
                type="text"
                [value]="
                  organization?.jpaContractor?.companyContactPhone1 ||
                  organization?.jpaContractor?.phoneNumber
                "
                disabled
              />
            </div> -->
            <h6 style="font-size: 12px; color: #00000066; font-weight: 400">
              Phone Number <span style="color: red">*</span>
            </h6>
            <h4 style="margin-top: -1rem; color: #505050">
              {{
                organization?.jpaContractor?.companyContactPhone1 ||
                  organization?.jpaContractor?.phoneNumber ||
                  "--"
              }}
            </h4>
          </div>
          <div class="ui divider"></div>
          <div class="required field" appMargin marginB="15px">
            <!-- <label>Website</label>
            <div class="ui input">
              <input
                type="text"
                [value]="organization?.jpaContractor?.website"
                disabled
              />
            </div> -->
            <h6 style="font-size: 12px; color: #00000066; font-weight: 400">
              Website <span style="color: red">*</span>
            </h6>
            <h4 style="margin-top: -1rem; color: #505050">
              {{ organization?.jpaContractor?.website || "--" }}
            </h4>
          </div>
          <div class="ui divider"></div>
        </form>
      </div>
      <!-- ------------------------------------------------------------------ -->

      <!-- COMPANY CEO INFORMATION -->
      <div class="ui segment" style="padding-right: 0px">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div fxFlex="grow" class="section-header">Company CEO Details</div>
          <div fxLayout="row" fxLayoutGap="10px">
            <!-- <button
              suiPopup
              [popupInverted]="true"
              popupPlacement="bottom"
              popupText="View History"
              (click)="viewHistory('CEO-INFORMATION')"
              class="ui tiny button"
            >
              <img
                style="position: relative; right: 0.7em; bottom: 0.1rem"
                src="/assets/icons/Group 416.svg"
              />
            </button> -->
            <button
              suiPopup
              [popupInverted]="true"
              popupPlacement="bottom"
              popupText="Edit Details"
              (click)="editCompanyCEOInfo()"
              class="ui tiny button"
            >
              <img
                style="position: relative; right: 0.5em; bottom: 0.1rem"
                src="/assets/icons/pen.svg"
              />
            </button>
          </div>
        </div>
        <div class="ui divider"></div>

        <form class="ui form" appMargin marginT="20px">
          <div class="required field" appMargin marginB="15px">
            <!-- <label>Name of the CEO</label>
            <div class="ui input">
              <input type="text" [value]="companyCEOInfo.ceoName" disabled />
            </div>
          </div> -->
            <h6 style="font-size: 12px; color: #00000066; font-weight: 400">
              Name of CEO <span style="color: red">*</span>
            </h6>
            <h4 style="margin-top: -1rem; color: #505050">
              {{ companyCEOInfo.ceoName || "--" }}
            </h4>
          </div>
          <div class="ui divider"></div>

          <div class="required field" appMargin marginB="15px">
            <!-- <label>Email Address</label>
            <div class="ui input">
              <input
                type="text"
                [value]="companyCEOInfo.ceoContactEmail"
                disabled
              />
            </div>
          </div> -->
            <h6 style="font-size: 12px; color: #00000066; font-weight: 400">
              Email Address <span style="color: red">*</span>
            </h6>
            <h4 style="margin-top: -1rem; color: #505050">
              {{ companyCEOInfo.ceoContactEmail || "--" }}
            </h4>
          </div>
          <div class="ui divider"></div>
          <div class="required field" appMargin marginB="15px">
            <h6 style="font-size: 12px; color: #00000066; font-weight: 400">
              Phone Number <span style="color: red">*</span>
            </h6>
            <h4 style="margin-top: -1rem; color: #505050">
              {{ companyCEOInfo.ceoContactPhone || "--" }}
            </h4>
          </div>
          <div class="ui divider"></div>
        </form>
      </div>
    </div>
  </div>
</div>
<ng-template let-context let-modal="modal" #uploadTemplate>
  <div class="header">Change Organization Logo</div>
  <div class="content">
    <!-- <div class="ui basic segment"> -->
    <div fxLayout="row" fxLayoutGap="10px">
      <div fxFlex="50%">
        <img-cropper
          #cropper
          [image]="data"
          [settings]="cropperSettings"
        ></img-cropper>
        <div class="file-upload">
          <input
            id="custom-input"
            type="file"
            accept=".jpg, .jpeg, .png"
            #uploader
            (change)="fileChangeListener($event)"
            placeholder="Browse for documents"
            onclick="value = null"
          />
        </div>
      </div>
      <div fxFlex="50%" class="text-right">
        <div>
          <img
            [src]="data?.image"
            [width]="cropperSettings.croppedWidth"
            [height]="cropperSettings.croppedHeight"
          />
        </div>
      </div>
    </div>
    <!-- </div> -->
  </div>
  <div class="actions">
    <button
      class="ui basic primary button"
      (click)="modal.deny('approved')"
      autofocus
    >
      Cancel
    </button>
    <button
      class="ui primary button"
      (click)="modal.approve('approved')"
      autofocus
    >
      Upload logo
    </button>
  </div>
</ng-template>
<!--
  <ng-template let-context let-modal="modal" #organizationProfileTemplate>
    <bpp-organization-email></bpp-organization-email>
    <div class="action">
        <button class="ui basic primary button" (click)="modal.deny('denied')">Cancel</button>
        <button class="ui primary button" (click)="modal.approve('approved')" autofocus>OK</button>
    </div>
  </ng-template> -->
